import type { FC, ReactNode } from "react";

export const OverlayFooter: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="flex-shrink-0 border-t border-slate-200 bg-slate-50 p-3 dark:border-slate-700 dark:bg-arti-background">
    {children}
  </div>
);
